import { trace } from 'rytm-helpers'
import Controller from './Controller'

import MMap from './../shared/MMap'

class MapsController extends Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e)
    this.initMaps()
  }
  addEventListeners() {
    super.addEventListeners()
  }
  removeEventListeners() {
    super.removeEventListeners()
  }

  /**
   * OWN
   */
  
  initMaps() {
    this.maps = []
    const container = document.querySelector(this.getContainerSelector())
    const list = [...container.querySelectorAll(".m-map")]
    list.forEach(this.initMap.bind(this))
  }

  initMap(el) {
    const $map = $(el);
    const id = el.id
    const dataSelector = el.dataset.mapData
    const $mapData = dataSelector ? $(dataSelector) : null
    if (!id || !$mapData) {
      trace("map init failed", el)
      return false
    }
    this.maps.push(new MMap({$map, id, $mapData}))
  }


}

export default MapsController;